const LEADING_ROUTE_WRAPPERS = new Set(['"', "'", "“", "‘"]);
const TRAILING_ROUTE_PUNCTUATION = new Set([".", ",", "!", "?", '"', "'", "”", "’"]);
const PARENT_AUTHORIZATION_ROUTE_PATTERN =
  /^\/parent-authorization\/[^/?#]+\/?$/u;
const REDACTED_PARENT_AUTHORIZATION_PATH =
  "/parent-authorization/[redacted]";

const decodePathSegment = (segment = "") => {
  try {
    return decodeURIComponent(segment);
  } catch {
    return segment;
  }
};

const normalizeRoutableSegment = (segment = "") => {
  const decodedSegment = decodePathSegment(String(segment || ""));
  let start = 0;
  let end = decodedSegment.length;

  while (start < end && LEADING_ROUTE_WRAPPERS.has(decodedSegment[start])) {
    start += 1;
  }

  while (end > start && TRAILING_ROUTE_PUNCTUATION.has(decodedSegment[end - 1])) {
    end -= 1;
  }

  return encodeURIComponent(decodedSegment.slice(start, end));
};

export const normalizeRoutablePathname = (pathname = "/") => {
  const rawPathname = String(pathname || "/");
  const segments = rawPathname.split("/");
  const lastSegmentIndex = [...segments]
    .map((segment, index) => ({ segment, index }))
    .reverse()
    .find(({ segment }) => Boolean(segment))?.index;

  if (typeof lastSegmentIndex !== "number") {
    return rawPathname;
  }

  const normalizedSegment = normalizeRoutableSegment(segments[lastSegmentIndex]);
  if (normalizedSegment === segments[lastSegmentIndex]) {
    return rawPathname;
  }

  const normalizedSegments = [...segments];
  normalizedSegments[lastSegmentIndex] = normalizedSegment;
  return normalizedSegments.join("/") || "/";
};

export const redactSensitiveRoutePathname = (pathname = "/") => {
  const normalizedPathname = String(pathname || "/").split(/[?#]/u, 1)[0];
  return PARENT_AUTHORIZATION_ROUTE_PATTERN.test(normalizedPathname)
    ? REDACTED_PARENT_AUTHORIZATION_PATH
    : normalizedPathname;
};
